module.exports = __webpack_public_path__ + "img/imgStep04.da33c191.png";